import events from './event.js';
import { imageUrl, getNumber } from './texts.js';

class CoverOverlay {
    coverLoadingOverlay = null;
    coverOverlayTimer = null;
    currentProductPermalink = null;

    constructor(parentElement) {
        this.parentElement = parentElement;
        this.init();
    }

    init() {
        // Skapa cover overlay-elementet
        this.coverLoadingOverlay = document.createElement('div');
        this.coverLoadingOverlay.classList.add('mscp-popup-cover-loading-overlay');

        // Lägg till elementet i parent
        this.parentElement.appendChild(this.coverLoadingOverlay);
    }

    /**
     * Visar cover overlay med bild och timer
     * @param {string} newStep - Steg-identifierare för vilken overlay som ska visas
     */
    async show(newStep, productPermalink = null) {
        if (!newStep) return;

        const coverOverlayImage = imageUrl(`${newStep}_overlay_image`);
        const coverOverlayTime = getNumber(`${newStep}_overlay_time`, '2000');

        if (coverOverlayImage) {
            this.clear();

            // Spara permalink så handleClick kan navigera direkt vid user gesture
            this.currentProductPermalink = productPermalink || null;

            const link = document.createElement('a');
            link.className = 'mscp-proceed-direct-link';
            link.href = productPermalink || '#';
            let img = document.createElement('img');
            img.src = coverOverlayImage;
            link.appendChild(img);

            // Lägg alltid till klick-lyssnare så att vi kontrollerar navigeringen via JS.
            // Detta säkerställer att user gesture → window.location.href fungerar i IAB (Instagram/Facebook)
            // och att externa klick-interceptors (tema-JS, WooCommerce) inte kan stoppa navigeringen.
            link.addEventListener('click', e => this.handleClick(e));

            this.coverLoadingOverlay.appendChild(link);
            this.coverLoadingOverlay.classList.add('active');
            this.coverLoadingOverlay.dataset.step = newStep;

            // Sätt timer för att automatiskt stänga overlayen (om det inte är gotoProduct-steps)
            if (newStep !== 'gotoProduct' && newStep !== 'gotoProduct_proceed' && newStep !== 'upload') {
                if (this.coverOverlayTimer) {
                    clearTimeout(this.coverOverlayTimer);
                }

                this.coverOverlayTimer = setTimeout(() => {
                    this.clear();
                }, coverOverlayTime);
            }
        }
    }

    /**
     * Tar bort cover overlay och rengör
     */
    clear() {
        this.coverLoadingOverlay.classList.remove('active');
        this.coverLoadingOverlay.dataset.step = null;
        this.coverLoadingOverlay.querySelectorAll('a').forEach(a => a.remove());
        this.currentProductPermalink = null;

        if (this.coverOverlayTimer) {
            clearTimeout(this.coverOverlayTimer);
            this.coverOverlayTimer = null;
        }
    }

    /**
     * Hanterar klick på cover overlay
     */
    handleClick(e) {
        e.stopPropagation();
        e.preventDefault();

        const step = this.coverLoadingOverlay.dataset?.step;

        // gotoProduct stegen hanterar sina egna timers och klick
        if (step && (step === 'gotoProduct' || step === 'gotoProduct_proceed')) {
            if (typeof hj === 'function') { hj('event', 'coverOverlay_gotoProduct_click'); }
            if (this.currentProductPermalink) {
                // Navigera direkt som user gesture – fungerar i IAB (Instagram/Facebook in-app browser)
                // där asynkron window.location.href (timer/await) kan blockeras
                window.location.href = this.currentProductPermalink;
            } else {
                // Permalink saknas ännu (data sparas fortfarande), använd event-systemet
                events.trigger('forceNavigateToProductPage');
            }
            return;
        }

        // Du kan inte hoppa över upload-loading
        if (step === 'upload') {
            return;
        }

        this.clear();
    }

    /**
     * Returnerar cover overlay-elementet
     */
    getElement() {
        return this.coverLoadingOverlay;
    }

    /**
     * Rengör och tar bort alla event listeners
     */
    destroy() {
        if (this.coverOverlayTimer) {
            clearTimeout(this.coverOverlayTimer);
            this.coverOverlayTimer = null;
        }
        if (this.coverLoadingOverlay) {
            this.coverLoadingOverlay.remove();
            this.coverLoadingOverlay = null;
        }
    }
}

export default CoverOverlay;
